module.exports = __webpack_public_path__ + "img/holofuel-logo.f99ead78.svg";